import { Component, OnDestroy, OnInit } from '@angular/core';
import { AuthService } from './shared/services/auth.service';
import { filter, Subscription } from 'rxjs';
import { PermissionModel } from './shared/models/navigation.model';
import { HomeService } from './shared/services/home.service';
import { MsalBroadcastService, MsalService } from "@azure/msal-angular";
import { InteractionStatus } from "@azure/msal-browser";
import { getRouteKeyMatchByUrl } from './shared/routes/helper';
import { Router } from '@angular/router';
import { FeatureFlagService } from './shared/services/feature-flag/feature-flag.service';
import { ScriptLoaderService } from './shared/services/script-loader.service';


@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit, OnDestroy {

  title = 'imperia';
  navigation: PermissionModel[];
  isAuthenticated = false;
  isLoading = false;

  private navigationSubs: Subscription;

  constructor(private readonly router: Router,
              private readonly authService: AuthService,
              private readonly homeService: HomeService,
              private readonly msalBroadcastService: MsalBroadcastService,
              private readonly msalService: MsalService,
              private readonly featureFlagService: FeatureFlagService,
              private readonly scriptLoaderService: ScriptLoaderService) { }

  ngOnInit(): void {
    // Expose MSAL service and instance to window for microfrontend to use
    (window as any).__hostMsalService = this.msalService;
    (window as any).__hostMsalInstance = this.msalService.instance;


    this.msalBroadcastService.inProgress$
      .pipe(
        filter((status: InteractionStatus) => status === InteractionStatus.None),
      )
      .subscribe({
        next: () => {
          if (this.msalService.instance.getAllAccounts().length > 0) {
            this.authService.getAuthData();
          } else {
            const scopes = ['openid', 'profile', 'email', 'offline_access'];

            // Add claims to request CustomRoles in tokens
            // by default these are not requested
            const claims = {
              id_token: {
                CustomRoles: null
              },
              access_token: {
                CustomRoles: null
              }
            };

            this.msalService.loginRedirect({
              scopes,
              claims: JSON.stringify(claims)
            });
          }
        }
      });
    this.authService.isAuthenticated.subscribe({
      next: (isAuthenticated) => {
        if (isAuthenticated) {
          this.isLoading = true;
          this.getAllFeatureFlags();
          this.getNavigation();
          this.authService.startTokenRefresh();
          // Load micro frontend scripts AFTER authentication is complete
          this.scriptLoaderService.loadMicroFrontEnds();

        }
      }
    });
  }

  ngOnDestroy(): void {
    if (this.navigationSubs) { this.navigationSubs.unsubscribe(); }
  }

  get hasUrlAccess(): boolean {
    const urlTriggered = window.location.pathname;
    const key = getRouteKeyMatchByUrl(urlTriggered);

    if (key) {
      const existInNavigation = this.compareUrlKey(key);
      return !!existInNavigation;
    } else {
      return true;
    }

  }

  private compareUrlKey(key: string, permsList: PermissionModel[] = this.navigation): PermissionModel {
    let result = null;
    permsList.find(perm =>
      result = perm.viewKey === key ? perm : this.compareUrlKey(key, perm.children));

    return result;
  }

  private getNavigation(): void {
    this.navigationSubs = this.homeService.getNavigation().subscribe(data => {
      if (data) {
        this.navigation = data.permissions;
        this.authService.setUserTableId(data?.userID, data?.externalLinks || []);
        this.isAuthenticated = true;
        this.isLoading = false;
        if (!this.hasUrlAccess) {
          void this.router.navigate(['/'])
        }
      } else {
        setTimeout(() => this.authService.logOut(), 2500);
        this.navigation = [];
        this.isAuthenticated = false;
        this.isLoading = false;
      }
    });
  }

  private getAllFeatureFlags(): void {
    this.featureFlagService.getAllFeatureFlags();
  }

}
